import { Link } from "react-router-dom";

// Framer Motion – motion
import { motion } from "framer-motion";
import { preloader, page_transition } from "../components/Animations";

// Meta Data (React Hemlet)
import GetMetaData from "../components/GetMetaData";
import imprintMeta from "../metaData/imprintMeta.json";
import metaImg_imprint from "../images/meta-images/gloryforkorn--og--imprint.jpg";

const Imprint = () => {
  return (
    <>
      <GetMetaData       
      ogSiteName={imprintMeta.ogSiteName} 
      title={imprintMeta.title} 
      ogTitle={imprintMeta.ogTitle}   
      twitterTitle={imprintMeta.twitterTitle}          
      description={imprintMeta.description} 
      ogDescription={imprintMeta.ogDescription} 
      twitterDescription={imprintMeta.twitterDescription}
      imageUrl={metaImg_imprint}     
      canonical={imprintMeta.canonical} 
      />

      <motion.div className="preloader" initial="preloader_initial" animate="preloader_animation" exit="preloader_exit" variants={preloader}></motion.div>
      <motion.div
        className="page-transition"
        initial="page_transition_initial"
        animate="page_transition_animate"
        exit="page_transition_exit"
        variants={page_transition}
      >
        <main page="imprint">
          <section className="section">
            <div className="xcontainer">
              <h1 className="tt--upper">Legal Notice</h1>

              <span className="contact-information">
                <p>
                  <strong>Pixellab Graphics</strong>
                  <br />
                  Leinenweberstraße 7
                  <br />
                  36251 Bad Hersfeld
                  <br />
                  Germany
                  <br />
                  <br />
                  E-Mail: info@pixellab.graphics
                  <br />
                  Internet: www.pixellab.graphics
                  <br />
                  <br />
                  <strong>Owner</strong>
                  <br />
                  Max Korn
                  <br />
                  Ust-IdNr.: DE330308016
                  <br />
                  <i>Sales tax identification number according to §27a sales tax law.</i>
                </p>
              </span>

              <h2>1. Terms</h2>
              <p>
                By accessing this Website, accessible from http://gloryforkorn.com/, you are agreeing to be bound by these Website Terms and Conditions of Use
                and agree that you are responsible for the agreement with any applicable local laws. If you disagree with any of these terms, you are prohibited
                from accessing this site. The materials contained in this Website are protected by copyright and trade mark law.
              </p>

              <h2>2. Use License</h2>

              <p>
                Permission is granted to temporarily download one copy of the materials on Glory for Korn's Website for personal, non-commercial transitory
                viewing only. This is the grant of a license, not a transfer of title, and under this license you may not:
              </p>

              <ul>
                <li>modify or copy the materials;</li>
                <li>use the materials for any commercial purpose or for any public display;</li>
                <li>attempt to reverse engineer any software contained on Glory for Korn's Website;</li>
                <li>remove any copyright or other proprietary notations from the materials; or</li>
                <li>transferring the materials to another person or "mirror" the materials on any other server.</li>
              </ul>

              <p>
                This will let Glory for Korn to terminate upon violations of any of these restrictions. Upon termination, your viewing right will also be
                terminated and you should destroy any downloaded materials in your possession whether it is printed or electronic format.
              </p>

              <h2>3. Disclaimer</h2>

              <p>
                All the materials on Glory for Korn’s Website are provided "as is". Glory for Korn makes no warranties, may it be expressed or implied,
                therefore negates all other warranties. Furthermore, Glory for Korn does not make any representations concerning the accuracy or reliability of
                the use of the materials on its Website or otherwise relating to such materials or any sites linked to this Website.
              </p>

              <h2>4. Limitations</h2>

              <p>
                Glory for Korn or its suppliers will not be hold accountable for any damages that will arise with the use or inability to use the materials on
                Glory for Korn’s Website, even if Glory for Korn or an authorize representative of this Website has been notified, orally or written, of the
                possibility of such damage. Some jurisdiction does not allow limitations on implied warranties or limitations of liability for incidental
                damages, these limitations may not apply to you.
              </p>

              <h2>5. Revisions and Errata</h2>

              <p>
                The materials appearing on Glory for Korn’s Website may include technical, typographical, or photographic errors. Glory for Korn will not
                promise that any of the materials in this Website are accurate, complete, or current. Glory for Korn may change the materials contained on its
                Website at any time without notice. Glory for Korn does not make any commitment to update the materials.
              </p>

              <h2>6. Links</h2>

              <p>
                Glory for Korn has not reviewed all of the sites linked to its Website and is not responsible for the contents of any such linked site. The
                presence of any link does not imply endorsement by Glory for Korn of the site. The use of any linked website is at the user’s own risk.
              </p>

              <h2>7. Site Terms of Use Modifications</h2>

              <p>
                Glory for Korn may revise these Terms of Use for its Website at any time without prior notice. By using this Website, you are agreeing to be
                bound by the current version of these Terms and Conditions of Use.
              </p>

              <h2>8. Your Privacy</h2>

              <p>Please read our Privacy Policy.</p>

              <h2>9. Governing Law</h2>

              <p>
                In order for consumers and traders to resolve a dispute out-of-court, the European Commission developed the Online Dispute Resolution Website:{" "}
                <a href="www.ec.europa.eu/consumers/odr">www.ec.europa.eu/consumers/odr</a>
              </p>
              <Link className="btn btn--1 btn--a mt--200" to="/">
                    Back
              </Link>
            </div>
          </section>
        </main>
      </motion.div>
    </>
  );
};

export default Imprint;
